export class SearchApiController {
  constructor(controller) {
    this.controller = controller;
  }

  async searchResultsCount() {
    try {
      const response = await this.fetchSearchResultsCount();
      return response.total_count;
    } catch (error) {
      console.error('Search API Error:', error);
      this.showErrorMessage(error.message);
      this.updateSubmitButton(1);
      throw error;
    }
  }

  async getSearchResultsCount() {
    return this.searchResultsCount();
  }

  buildSearchParams() {
    const params = new URLSearchParams();

    if (this.controller.formValue.prefecture_id) {
      params.append('prefecture_id', this.controller.formValue.prefecture_id);
    }
    if (this.controller.formValue.city_id) {
      params.append('city_id', this.controller.formValue.city_id);
    }
    if (this.controller.formValue.categories && this.controller.formValue.categories.length > 0) {
      this.controller.formValue.categories.forEach(category => {
        params.append('categories[]', category);
      });
    }
    if (this.controller.formValue.part_types && this.controller.formValue.part_types.length > 0) {
      this.controller.formValue.part_types.forEach(partType => {
        params.append('part_types[]', partType);
      });
    }

    return params;
  }

  async fetchSearchResultsCount() {
    const baseUrl = '/subsidies/api/search_result';
    const searchParams = this.buildSearchParams();
    const url = `${baseUrl}?${searchParams.toString()}`;
    
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        if (response.status >= 500) {
          throw new Error('サーバーエラーが発生しました。しばらくしてから再試行してください');
        } else {
          throw new Error(`通信エラーが発生しました (${response.status})`);
        }
      }

      const data = await response.json();
      return data;
    } catch (error) {
      // ネットワークエラーや JSON パースエラーなどのキャッチ
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        throw new Error('ネットワーク接続に問題があります。接続を確認してください');
      } else if (error instanceof SyntaxError) {
        throw new Error('サーバーからの応答形式に問題があります');
      }
      throw error;
    }
  }

  updateSubmitButton(count) {
    const submitButton = this.controller.element.querySelector('.subsidies-search-panel__submit-button');
    if (submitButton) {
      if (count === 0) {
        submitButton.disabled = true;
        submitButton.style.background = '#ddd';
        submitButton.style.color = '#707070';
        submitButton.value = '検索する';
        submitButton.style.opacity = '';
        if (this.controller.hasSubmitNoResultsMessageTarget) {
          this.controller.submitNoResultsMessageTarget.style.display = 'block';
        }
      } else {
        submitButton.disabled = false;
        submitButton.style.background = '';
        submitButton.style.color = '';
        submitButton.value = '検索する';
        submitButton.style.opacity = '';
        if (this.controller.hasSubmitNoResultsMessageTarget) {
          this.controller.submitNoResultsMessageTarget.style.display = 'none';
        }
      }
    }
  }

  showErrorMessage(message) {
    // エラーメッセージ表示用の要素があれば表示
    const errorElement = this.controller.element.querySelector('.subsidies-search-panel__error-message');
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
      
      // 5秒後に自動的に非表示
      setTimeout(() => {
        errorElement.style.display = 'none';
      }, 5000);
    } else {
      // エラー要素がない場合はコンソールに出力
      console.error('検索エラー:', message);
    }
  }
}
